/** TW4 `translate-*` utilities use the CSS `translate` property, not `transform`. */
export const SLIDE_PANEL_TRANSITION_CLASS =
  'transition-[opacity,translate,visibility] duration-500';

/** Mobile mini PDP also uses imperative `transform` during swipe gestures. */
export const MOBILE_MINI_PDP_PANEL_TRANSITION_CLASS =
  'transition-[opacity,transform,translate,visibility] duration-700 ease-[cubic-bezier(0.32,0.72,0,1)]';

export const MOBILE_MINI_PDP_TRANSITION_MS = 700;
export const PANEL_EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
